import { LAST_MONTH, PROVIDER_ID_FROM_P2P, PROVIDER_ID_TO_P2P, SELECT_PERIOD, THIS_MONTH } from 'apps/auth/constants/Constants';
import {
    AGENT_TO_LIBRE,
    CASH_DELIVERY,
    CASH_PICKUP,
    CASH_WITHDRAWAL,
    DELIVERY,
    EXCHANGE,
    INTERAC,
    INTERNAL_TRANSFER_IN,
    OFFLINE_PAYMENT,
    ONLINE_PAYMENT,
    REFUND,
    REPAYMENT,
    TO_BANK,
    TOP_UP,
    TRANSFER_IN,
    TRANSFER_OUT,
    UNKNOWN,
} from 'apps/auth/constants/GaConstants';
import { getIsoDate } from 'apps/auth/helpers/utils';

export const getIconName = (icon, item) => {
    // icon === REDEMPTION,PAYSEND_LOGO, INVITE return ''
    if (item.patternId === AGENT_TO_LIBRE) {
        return 'person';
    } else if (icon === TOP_UP) {
        return 'plus';
    } else if (icon === EXCHANGE) {
        return 'arrow-exchange';
    } else if (icon === ONLINE_PAYMENT) {
        return 'cloud';
    } else if (icon === OFFLINE_PAYMENT) {
        return 'shopping-bag';
    } else if (icon === CASH_WITHDRAWAL) {
        return 'cash-stack';
    } else if (
        item &&
        (item.frPrvId === PROVIDER_ID_FROM_P2P || item.frPrvId === PROVIDER_ID_TO_P2P) &&
        (item.toPrvId === PROVIDER_ID_FROM_P2P || item.toPrvId === PROVIDER_ID_TO_P2P)
    ) {
        return 'person';
    } else if (icon === INTERNAL_TRANSFER_IN || icon === TO_BANK) {
        return 'bank';
    } else if (icon === TRANSFER_IN) {
        return 'person';
    } else if (icon === TRANSFER_OUT) {
        return 'card';
    } else if (icon === DELIVERY) {
        return 'truck';
    } else if (icon === UNKNOWN) {
        return 'ghost';
    } else if (icon === REFUND) {
        return 'arrow-back-circular';
    } else if (icon === REPAYMENT) {
        return 'coins';
    } else if (icon === CASH_PICKUP || icon === CASH_DELIVERY) {
        return 'cash-stack';
    } else if (icon === INTERAC) {
        return 'interac';
    } else {
        return 'card';
    }
};
const toIsoString = (string) => {
    if (string) {
        return string.toISOString().slice(0, 10);
    }
};
export const getDateForServer = (period, fields = {}) => {
    const result = {
        dateBegin: '',
        dateEnd: '',
    };
    const today = new Date();
    if (period === THIS_MONTH) {
        result.dateEnd = toIsoString(today);
        today.setDate(1);
        result.dateBegin = toIsoString(today);
    } else if (period === LAST_MONTH) {
        today.setMonth(today.getMonth());
        today.setDate(0);
        result.dateEnd = toIsoString(today);
        today.setDate(1);
        result.dateBegin = toIsoString(today);
    } else if (SELECT_PERIOD) {
        const { end_date: { value: end_value } = {}, start_date: { value: start_value } = {} } = fields;
        result.dateEnd = getIsoDate(end_value);
        result.dateBegin = getIsoDate(start_value);
    }
    return result;
};
